<script setup lang="ts">
import {ref} from "vue";
import {CustomFile} from "@/types";
import {loadVideo} from "@/utils/common.ts";
import {CircleCheckFilled, Loading} from "@element-plus/icons-vue";

defineProps<{
  uploadStatus: number
  videoProgress: number
}>()

const upload = ref<HTMLInputElement>()

const emit = defineEmits(["onVideoFileChange", "onCancelUpload", "onClear"])

const filename = ref<string>("")

const onFileChange = () => {
  if (upload.value && upload.value.files && upload.value.files.length > 0) {
    const file = upload.value.files[0] as CustomFile
    loadVideo(file).then((video) => {
      file.duration = Math.ceil(video.duration)
      file.width = video.videoWidth
      file.height = video.videoHeight
      emit('onVideoFileChange', file)
    })
  }
}

const onStartUpload = (file: CustomFile) => {
  filename.value = file.name
}

const onCancelUpload = () => {
  emit("onCancelUpload")
}

const onClear = () => {
  filename.value = "";
  emit("onClear")
}

const init = (_filename: string) => {
  filename.value = _filename
}

defineExpose({
  onStartUpload, init
})
</script>

<template>
  <div class="w-full">
    <div class="flex items-center">
      <div>
        <label class="px-15px py-8px bg-#FF6600CC text-white cursor-pointer rounded hover:bg-#fb7139 text-14px" for="upload">
          <template v-if="filename">
            更换视频
          </template>
          <template v-else>
            上传视频
          </template>
        </label>
        <input accept=".mp4" ref="upload" type="file" id="upload" class="hidden" @change="onFileChange" />
      </div>
      <el-button type="danger" @click="onCancelUpload" class="ml-1rem" v-if="uploadStatus === 1">
        取消上传
      </el-button>
      <el-button type="danger" @click="onClear" class="ml-1rem" v-if="uploadStatus === 2">
        清除视频
      </el-button>
    </div>
    <div class="mt-1rem flex items-center" v-if="filename">
      <div class="text-#939393 mr-.5rem">{{ filename }}</div>
      <el-icon v-if="uploadStatus === 2"><CircleCheckFilled /></el-icon>
      <el-icon v-else-if="uploadStatus === 1" class="animate-spin"><Loading /></el-icon>
    </div>
    <div class="mt-1rem" v-if="uploadStatus === 1">
      <el-progress :percentage="videoProgress" />
    </div>
  </div>
</template>

<style scoped>
</style>
